import Cookies from 'js-cookie';
import { post } from './ApiService';
import { persistUserIdentity, clearStoredIdentity } from "./sessionIdentity";

export const guest = async () => {
    clearStoredIdentity();

    Cookies.set("token", "11771177", {
      expires: 365 * 3,
      path: "/",
      sameSite: 'Strict',
      secure: window.location.protocol === 'https:'
    });

  return true;
};

export const login = async (email, password, action) => {
  const data = await post('/auth', { email, password, action });

  if (data.user) {
    Cookies.set('token', data.user.token, {
      expires: 365 * 3,
      path: '/',
      sameSite: 'Strict',
      secure: window.location.protocol === 'https:'
    });
    persistUserIdentity(data.user);
  }

  return data;
};

export const register = async (name, email, password, action) => {
  const data = await post('/auth/register', { name, email, password, action });

  if (data.user) {
    Cookies.set('token', data.user.token, {
      expires: 365 * 3,
      path: '/',
      sameSite: 'Strict',
      secure: window.location.protocol === 'https:',
    });
    persistUserIdentity(data.user);
  }

  return data;
};

export const requestPasswordReset = async (email) => {
  const data = await post('/auth', { email, action: 'forgot_password' });
  return data;
};

export const logout = () => {
  clearStoredIdentity();
  Cookies.remove('token', { path: '/' });
};
